import { createFileRoute } from '@tanstack/react-router';

import { EvidenceInboxView } from '../../features/inbox/evidence-inbox-view';

// section, breadcrumb ("Inbox"), layout ("full-height") and
// resetSearchOnPartnerChange are all inherited from the parent `/inbox`
// layout route.
export const Route = createFileRoute('/inbox/')({
  component: EvidenceInboxView,
});
